/**
 * AccessDenied page.
 *
 * Displayed when user navigates to a resource they lack permission for.
 * Shows "Access Denied" message with a "Go Back" button.
 */

import { Button } from "@frontend/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@frontend/components/ui/card"
import { useNavigate } from "react-router"

export function AccessDenied() {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="text-center">Access Denied</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">You don't have permission to view this resource.</p>
          <div className="flex justify-center">
            <Button variant="outline" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
